import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaBlock } from './ui/CtaBlock';
import { testimonials } from '../data/content';
function initials(name: string) {
  return name.split(' ').map(part => part[0]).slice(0, 2).join('');
}
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="border-b border-crema bg-crema/60" data-id="element-142" data-mp="3ayi09lag3jqs">
      <div className="mx-auto max-w-3xl px-4 py-6 sm:py-9" data-id="element-143" data-mp="370aicn48wce0">
        <SectionHeader id="testimonios" title="Lo que dicen quienes ya empezaron" description="De sentirse estancados y desorganizados a comenzar a recuperar claridad y dirección." data-id="element-144" data-mp="31zmsi4rr61ld" />
        <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-145" data-mp="2s3081h3c9cjv">
          {testimonials.map((t, i) => <li key={t.author} className={`flex flex-col rounded-xl border border-crema bg-blanco p-3 ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-146" data-mp="v85alzo35h3u" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-147" data-mp="h8azlhcfuxst">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={13} aria-hidden="true" className="fill-dorado text-dorado" data-id="element-148" data-mp="78k35a4bi8q3" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1.5 text-[0.8rem] leading-snug text-azul sm:text-sm" data-id="element-149" data-mp="c73r1g2h1ul3">“{t.quote}”</blockquote>
              <div className="mt-auto flex items-center gap-2.5 pt-2.5" data-id="element-150" data-mp="zyiujc5zihxx">
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-petroleo text-xs font-extrabold text-blanco" data-id="element-151" data-mp="14uzm6gce7efr">
                  {initials(t.author)}
                </span>
                <div className="min-w-0" data-id="element-152" data-mp="v3wmniz437il">
                  <p className="text-sm font-extrabold text-azul" data-id="element-153" data-mp="1ius7tx92b4gv">{t.author}</p>
                  <p className="text-xs leading-tight text-azul/70" data-id="element-154" data-mp="1nm0ggr2kilsz">{t.meta}</p>
                </div>
              </div>
            </li>)}
        </ul>
        <CtaBlock data-id="element-155" data-mp="1xhh5dtjr77km" />
      </div>
    </section>;
}